<div class="w-full my-1 flex flex-col flex-nowrap align-top">
  <div class="w-full my-1 flex flex-row flex-nowrap justify-start" *ngIf="this._deactivableControl && this?.props?.isEditable">
    <om-label *ngIf="this.props?.deactivable?.label" [text]="this.props?.deactivable?.label" class="mx-1"></om-label>
    <nz-switch nzSize="small" [formControl]="this._deactivableControl" class="mx-1 w-full pt-1"></nz-switch>
  </div>
  <ng-container #fieldComponent *ngIf="this?.props?.isEditable || !this._deactivableControl || this._deactivableControl?.value === true">
  </ng-container>
</div>
